import React from "react";
import { Box } from "@mui/material";
import {
  MyCafeteriaVbkApplicationTableHeader,
  MyCafeteriaVbkApplicationTableRow,
} from "my-cafeteria/components";
import { useMyCafeteriaCurrentStatementItems } from "my-cafeteria/hooks";
import { useOcCurrentUserState } from "oc/hooks";

interface MyCafeteriaVbkApplicationTableProps {
  isMobile: boolean;
}

export const MyCafeteriaVbkApplicationTable = ({
  isMobile,
}: MyCafeteriaVbkApplicationTableProps) => {
  let { contractCode } = useOcCurrentUserState();
  const { data: statementItems } = useMyCafeteriaCurrentStatementItems({
    contractCode,
  });

  return (
    <Box>
      <MyCafeteriaVbkApplicationTableHeader isMobile={isMobile} />
      {statementItems?.map((item: any, index: number) => (
        <MyCafeteriaVbkApplicationTableRow
          key={`data-row-${index}`}
          benefit={item.menuItem.name}
          months={item.months}
          numberOfMonths={item.numberOfMonths}
          amount={item.amount}
          valueOfBenefit={item.valueOfBenefit}
          cost={item.cost}
          isMobile={isMobile}
        />
      ))}
    </Box>
  );
};

export default MyCafeteriaVbkApplicationTable;
